export interface Client {
  name: string;
  country: string;
  flag: string;
  amount: number;
  currency: string;
  contract: "A" | "B" | "C";
  yield: number;
  timeAgo: string;
}

const names = [
  "Александър П.", "Мария Д.", "Иван С.", "Елена К.", "Георги Т.",
  "Николай В.", "Анна М.", "Димитър Р.", "Светлана Б.", "Петър Н.",
  "Алексей К.", "Наталья В.", "Сергей М.", "Ольга Т.", "Дмитрий Л.",
  "Екатерина С.", "Андрей Ф.", "Татьяна Р.", "Михаил Д.", "Ирина Б.",
  "Marco R.", "Giulia F.", "Luca M.", "Sofia B.", "Alessandro C.",
  "Francesca T.", "Matteo V.", "Elena G.", "Roberto P.", "Chiara N.",
  "James W.", "Emma L.", "Oliver H.", "Charlotte B.", "William T.",
  "Sophia M.", "Benjamin K.", "Amelia R.", "Lucas D.", "Isabella F.",
  "Hans M.", "Ingrid S.", "Klaus B.", "Helga W.", "Friedrich N.",
  "Anna K.", "Werner T.", "Monika R.", "Dieter F.", "Ursula H.",
  "Pierre D.", "Marie C.", "Jean-Paul B.", "Sophie L.", "François M.",
  "Isabelle T.", "Philippe R.", "Nathalie V.", "Laurent G.", "Céline B.",
  "Carlos M.", "Ana García", "José R.", "María L.", "Antonio F.",
  "Carmen S.", "Miguel Á.", "Isabel T.", "Francisco V.", "Lucía N.",
  "Jan K.", "Anna W.", "Piotr M.", "Katarzyna B.", "Tomasz R.",
  "Magdalena S.", "Krzysztof N.", "Agnieszka T.", "Marek F.", "Joanna L.",
  "Nikos P.", "Maria K.", "Dimitris T.", "Elena V.", "Kostas M.",
  "Yiannis B.", "Sophia R.", "Andreas L.", "Christina F.", "Stavros N.",
  "Lukas H.", "Petra M.", "Martin S.", "Jana K.", "Pavel R.",
  "Zuzana T.", "Ondrej B.", "Lenka V.", "Tomas F.", "Marketa N.",
];

const countries = [
  { name: "България", flag: "🇧🇬" },
  { name: "Россия", flag: "🇷🇺" },
  { name: "Italia", flag: "🇮🇹" },
  { name: "United Kingdom", flag: "🇬🇧" },
  { name: "Deutschland", flag: "🇩🇪" },
  { name: "France", flag: "🇫🇷" },
  { name: "España", flag: "🇪🇸" },
  { name: "Polska", flag: "🇵🇱" },
  { name: "Ελλάδα", flag: "🇬🇷" },
  { name: "Česká republika", flag: "🇨🇿" },
  { name: "Nederland", flag: "🇳🇱" },
  { name: "Schweiz", flag: "🇨🇭" },
  { name: "Austria", flag: "🇦🇹" },
  { name: "Portugal", flag: "🇵🇹" },
  { name: "România", flag: "🇷🇴" },
];

const timeOptions = [
  "2 мин назад", "5 мин назад", "8 мин назад", "12 мин назад",
  "15 мин назад", "23 мин назад", "31 мин назад", "47 мин назад",
  "1 час назад", "2 часа назад", "3 часа назад",
];

const contractData = [
  { id: "A" as const, amount: 38965, yield: 68 },
  { id: "B" as const, amount: 50123, yield: 97 },
  { id: "C" as const, amount: 72434, yield: 113 },
];

function seededRandom(seed: number): number {
  const x = Math.sin(seed + 1) * 10000;
  return x - Math.floor(x);
}

export const clients: Client[] = names.map((name, i) => {
  const countryIdx = Math.floor(seededRandom(i * 3) * countries.length);
  const contractIdx = Math.floor(seededRandom(i * 7 + 2) * contractData.length);
  const timeIdx = Math.floor(seededRandom(i * 11 + 5) * timeOptions.length);
  const c = contractData[contractIdx];
  return {
    name,
    country: countries[countryIdx].name,
    flag: countries[countryIdx].flag,
    amount: c.amount,
    currency: "EUR",
    contract: c.id,
    yield: c.yield,
    timeAgo: timeOptions[timeIdx],
  };
});
